import { TemplateConfig } from '../types';

export const peekInnerHeartConfig: TemplateConfig = {
  id: 'peek-inner-heart',
  name: '窥探内心牌阵',
  description: '分析情感关系中双方的内心状态和发展走向',
  cardCount: 5,

  fieldDefaults: {
    title: '窥探内心牌阵',
    customerQuestion: '分析我和对方之间的感情走向。',
    cardPlaceholders: [
      '请输入第 1 行第 1 张牌',
      '请输入第 3 行第 1 张牌',
      '请输入第 2 行第 1 张牌',
      '请输入第 2 行第 2 张牌',
      '请输入第 3 行第 2 张牌'
    ],
    cardInfos: [
      '对方想从我的身上得到什么',
      '对方对我的喜欢程度',
      '对方的阴暗面',
      '关系中是否存在第三方',
      '计划这段感情的态度'
    ]
  },

  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],

  generateOptions: {
    normal: true,
    thinking: true
  },

  ui: {
    color: '#f759ab',
    backgroundColor: '#fff0f6',
    icon: '💕'
  }
};
